import script from "./registerSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./registerSteps.vue?vue&type=script&setup=true&lang=js"

import "./registerSteps.vue?vue&type=style&index=0&id=aac58976&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aac58976"]])

export default __exports__